// extracted by mini-css-extract-plugin
export default {"modal":"dJwHNkMoD8AR6AHvHxf1","content":"cgos_pPsDgukky7elRX5"};